import { getClosestAncestor } from 'src/public-resource/libs/utils/domUtil.js'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform.js'
import Bridge from 'src/frontend-lib/lib/Bridge.js'
import Stat from 'src/frontend-lib/lib/stat/Stat.js'

// 实现的功能都是：区域点击 && 埋点
export class LinkHandler {
  constructor() {
    this.$platform = getPlatform()
    this.$bridge = new Bridge()
    this.$stat = new Stat()
    this.handleLessonButton()
    this.handleTestButton()
    this.handleArticleItemClick()
    this.handleQaItemClick()
    this.handleAnswerItemClick()
    this.handleStoryItemClick()
    this.handleHotItemClick()
    this.handleDynamicsItemClick()
    this.handleFmAndBodanClick()
    this.handlePersonalInfo()
    this.handleNewTopic()
  }

  _goToPage(event, href) {
    event.preventDefault()
    if (this.$platform.isYixinliApp) {
      if (href.indexOf('yixinli://') === 0) {
        window.location.href = href
      } else {
        this.$bridge.call('openWebView', {
          url: href,
          isCurrentPageOpen: 0
        })
      }
      return
    }
    if (!sessionStorage.getItem('app_show_flag')) {
      // 引导到app的弹窗
      window.handleToApp(event, { href })
    } else {
      window.location.href = href
    }
  }

  // 给列表item进行事件绑定
  _bindItems(selector, callback) {
    if (typeof callback !== 'function') return
    const items = Array.from(document.querySelectorAll(selector))
    items.forEach(item => {
      item.addEventListener('click', event => {
        callback(event, item)
      })
    })
  }

  // 课程
  handleLessonButton() {
    this._bindItems('.lessonItem', (event, item) => {
      const target = event.target
      // 只在立即抢购按钮和a标签跳转，其他地方不跳转
      if (
        !getClosestAncestor(target, 'btn-default') &&
        !getClosestAncestor(target, 'lesson-name')
      ) {
        return
      }

      const title = item.querySelector('.lesson-name').textContent
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          行为: '点击',
          页面: '专题模板页',
          对象: title || '',
          业务: '课程',
          页面标题: window.baseInfo.activity.name
        }
      })
      const href = item.querySelector('.lesson-name').href
      this._goToPage(event, href)
    })
  }

  // 测评
  handleTestButton() {
    this._bindItems('.testItem', (event, item) => {
      const target = event.target
      // 只在测试按钮和a标签跳转，其他地方不跳转
      if (
        !getClosestAncestor(target, 'btn-default') &&
        !getClosestAncestor(target, 'test-name')
      ) {
        return
      }

      const title = item.querySelector('.test-name').textContent
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          行为: '点击',
          页面: '专题模板页',
          对象: title || '',
          业务: '测评',
          页面标题: window.baseInfo.activity.name
        }
      })
      const href = item.querySelector('.test-name').href
      this._goToPage(event, href)
    })
  }

  // 文章
  handleArticleItemClick() {
    this._bindItems('.article_list', (event, item) => {
      const title = item.querySelector('.article_item').getAttribute('title')
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          行为: '点击',
          页面: '专题模板页',
          对象: title || '',
          业务: '文章',
          页面标题: window.baseInfo.activity.name
        }
      })
      const href = item.querySelector('.article_title').href
      this._goToPage(event, href)
    })
  }

  // 问答
  handleQaItemClick() {
    this._bindItems('.ask-item', (event, item) => {
      const title = item.getAttribute('title')
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          行为: '点击',
          页面: '专题模板页',
          对象: title || '',
          业务: '问答',
          页面标题: window.baseInfo.activity.name
        }
      })
      const href = item.querySelector('.item-text').href
      this._goToPage(event, href)
    })
  }

  // 回答
  handleAnswerItemClick() {
    this._bindItems('.answer_ul .answer_item', (event, item) => {
      this._goToPage(event, item.href)
    })
  }

  // 故事集·书写计划
  handleStoryItemClick() {
    this._bindItems('.story-item', (event, item) => {
      const textEl = item.querySelector('.story-text')
      this.$stat.interact({
        businessType: '公共',
        category: '专题模板',
        eventValue: '故事集/书写计划',
        pageTitle: '专题活动页面',
        extraAttr: {
          行为: '点击',
          标题: textEl.textContent.trim()
        }
      })
      const href = textEl.href
      this._goToPage(event, href)
    })
  }

  // 心理圈·热门话题
  handleHotItemClick() {
    this._bindItems('.hot-topic-item', (event, item) => {
      this.$stat.interact({
        businessType: '公共',
        category: '专题模板',
        eventValue: '心理圈-话题',
        pageTitle: '专题活动页面',
        extraAttr: {
          行为: '点击',
          话题ID: +item.getAttribute('data-id')
        }
      })
      const href = item.querySelector('.hot-topic-text').href
      this._goToPage(event, href)
    })
  }

  // 心理圈·动态
  handleDynamicsItemClick() {
    this._bindItems('.dynamics-item', (event, item) => {
      // 1.点击头像和昵称会跳到别的地方，因此要return掉
      const target = event.target
      if (
        getClosestAncestor(target, 'dynamics-avatar-wrap') ||
        getClosestAncestor(target, 'dynamics-info-name')
      ) {
        return
      }

      this.$stat.interact({
        businessType: '公共',
        category: '专题模板',
        eventValue: '心理圈-动态内容',
        pageTitle: '专题活动页面',
        extraAttr: {
          行为: '点击',
          动态ID: +item.getAttribute('data-id')
        }
      })
      const href = item.querySelector('.dynamics-text').href

      event.preventDefault()
      if (this.$platform.isYixinliApp) {
        // const id = +item.getAttribute('data-id') // 必填，动态的id
        // window.location.href = `yixinli://open_dynamic_detail?id=${id}`
        window.myBrige.call('openWebView', {
          url: href
        })
        return
      }
      if (!sessionStorage.getItem('app_show_flag')) {
        // 引导到app的弹窗
        window.handleToApp(event, { href })
      } else {
        window.location.href = href
      }
    })
  }

  // FM && FM播单
  handleFmAndBodanClick() {
    this._bindItems('.mind-item', (event, item) => {
      if (getClosestAncestor(item, 'fm-bodan')) {
        this._handleBodan(event, item)
      } else {
        this._handleFm(event, item)
      }
    })
  }

  _handleFm(event, item) {
    const title = item.getAttribute('title')
    window.yxl.stat.send({
      name: '公共-交互行为',
      properties: {
        行为: '点击',
        页面: '专题模板页',
        对象: title || '',
        业务: '心事',
        页面标题: window.baseInfo.activity.name
      }
    })
    const href = item.querySelector('.mind-text').href
    this._goToPage(event, href)
  }

  _handleBodan(event, item) {
    this.$stat.interact({
      businessType: '公共',
      category: '专题模板',
      eventValue: 'FM播单',
      pageTitle: '专题活动页面',
      extraAttr: {
        行为: '点击',
        播单ID: +item.getAttribute('data-id')
      }
    })
    const href = item.querySelector('.mind-text').href
    this._goToPage(event, href)
  }

  // 个人信息
  handlePersonalInfo() {
    this._bindItems('.my-info-container', (event, item) => {
      event.preventDefault()
      this.$stat.interact({
        businessType: '公共',
        category: '专题模板',
        eventValue: '个人信息组件',
        pageTitle: '专题活动页面',
        extraAttr: {
          行为: '点击',
          用户ID: +item.getAttribute('data-id')
        }
      })
      const href = item.href
      this._goToPage(event, href)
    })
  }

  // 新增话题模块
  handleNewTopic() {
    this._bindItems('.new-topic-wrap .new-topic-item', (event, item) => {
      event.preventDefault()
      this._goToPage(event, item.href)
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/promotion/template/js/LinkHandler.js